import React from 'react';
import { LayoutGrid, Calendar, PlusCircle, BarChart2, LogOut } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function BottomNav() {
  const location = useLocation();
  const path = location.pathname;
  const { logout } = useAuth();

  const isActive = (route) => {
    if (route === '/') return path === '/';
    return path.startsWith(route);
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center h-[68px] z-40 pb-safe shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] rounded-t-2xl">
      <Link to="/" className={`flex flex-col items-center justify-center w-full h-full ${isActive('/') ? 'text-blue-700' : 'text-slate-500 hover:text-slate-700'}`}>
        <LayoutGrid className="w-[22px] h-[22px] mb-1" />
        <span className="text-[11px] font-semibold">Home</span>
        <div className={`w-1 h-1 rounded-full mt-0.5 ${isActive('/') ? 'bg-blue-700' : 'bg-transparent'}`}></div>
      </Link>
      
      <Link to="/months" className={`flex flex-col items-center justify-center w-full h-full ${isActive('/month') ? 'text-blue-700' : 'text-slate-500 hover:text-slate-700'}`}>
        <Calendar className="w-[22px] h-[22px] mb-1" />
        <span className="text-[11px] font-semibold">Months</span>
        <div className={`w-1 h-1 rounded-full mt-0.5 ${isActive('/month') ? 'bg-blue-700' : 'bg-transparent'}`}></div>
      </Link>
      
      <Link to="/new" className={`flex flex-col items-center justify-center w-full h-full ${isActive('/new') ? 'text-blue-700' : 'text-slate-500 hover:text-slate-700'}`}>
        <PlusCircle className="w-[22px] h-[22px] mb-1" />
        <span className="text-[11px] font-semibold">New</span>
        <div className={`w-1 h-1 rounded-full mt-0.5 ${isActive('/new') ? 'bg-blue-700' : 'bg-transparent'}`}></div>
      </Link>
      
      <Link to="/reports" className={`flex flex-col items-center justify-center w-full h-full ${isActive('/reports') ? 'text-blue-700' : 'text-slate-500 hover:text-slate-700'}`}>
        <BarChart2 className="w-[22px] h-[22px] mb-1" />
        <span className="text-[11px] font-semibold">Reports</span>
        <div className={`w-1 h-1 rounded-full mt-0.5 ${isActive('/reports') ? 'bg-blue-700' : 'bg-transparent'}`}></div>
      </Link>
      
      <button onClick={logout} className="flex flex-col items-center justify-center w-full h-full text-slate-500 hover:text-slate-700">
        <LogOut className="w-[22px] h-[22px] mb-1" />
        <span className="text-[11px] font-semibold">Logout</span>
        <div className="w-1 h-1 rounded-full mt-0.5 bg-transparent"></div>
      </button>
    </div>
  );
}
